import React from 'react';
import * as registration from '../machines/accountRegistration';
import lang from '../lang';
import {UseMachineType} from '../machines/useAccountRegistrationMachineType';
import {AlreadyRegisteredHint, AlreadyRegisteredLinks} from '../data/types';

type Props = {
  registrationMachine: UseMachineType;
};

export type AlreadyRegisteredComponentProps = {
  lang: typeof lang.alreadyRegistered;
  message: string;
  links: AlreadyRegisteredLinks;
  email: string;
  onUseDifferentEmailClick: () => unknown;
};

export type AlreadyRegisteredScreenProps = Props &
  AlreadyRegisteredComponentProps & {
    onPrimaryActionClick: () => unknown;
  };

export type AlreadyRegisteredScreenType =
  React.ComponentType<AlreadyRegisteredScreenProps>;

export function AlreadyRegistered(
  props: Props & {
    children: AlreadyRegisteredScreenType;
  }
) {
  const [
    {
      context: {
        navigator: {location},
      },
    },
    send,
  ] = props.registrationMachine;

  const message: string =
    (location.state.message as string | undefined) ??
    'Your email was confirmed previously. Click the button below to log in.';
  const hint = location.state.hint as AlreadyRegisteredHint;
  const links = hint?.links || {};
  const email = hint?.email ?? '';
  const onPrimaryActionClick = () =>
    send(registration.RegistrationEvent.GO_TO_LOGIN);
  const onUseDifferentEmailClick = () =>
    send(registration.RegistrationEvent.SKIP_TO_EMAIL);

  const renderProps: AlreadyRegisteredScreenProps = {
    ...props,
    lang: lang.alreadyRegistered,
    links,
    email,
    message,
    onPrimaryActionClick,
    onUseDifferentEmailClick,
  };

  const Screen = props.children;
  return <Screen {...renderProps} />;
}
